// Copyright 2026. WebPros International GmbH. All rights reserved.

export const DISASTER_RECOVERY_HISTORY = {
    RETRY_FAILED_BUTTON: 'dr-history-retry-failed-failed',
    VIEW_ORIGINAL_DATA_FOR_SELECTION: 'dr-history-view-original-data',
    DELETE_ORIGINAL_DATA_FOR_SELECTION: 'dr-history-delete-original-data',
    DELETE_ORIGINAL_DATA_MANUALLY: 'dr-history-delete-original-data-manually',
    ENTITY_STATUS_MODAL: 'dr-history-entity-status-modal',
    DELETE_ORIGINAL_DATA_FOR_ENTITY: 'dr-history-delete-original-data-for-entity',
    VIEW_ORIGINAL_DATA_FOR_ENTITY: 'dr-history-view-original-data-for-entity',
    DOWNLOAD_ORIGINAL_DATA: 'dr-history-download-original-data',
};
